<template>
  <v-layout justify-center mb-2 row>
    <State :id="props.item.id" :state="props.item.state" style="float:left;margin-right: -.7rem"/>
    <Tooltip v-slot:default="{on}" text="Edytuj">
      <router-link
          :to="{ name:'form-edit', params: { schemaId: $route.params.schemaId, formId: props.item.id  }}"
          class="dropdown-item">
        <v-btn fab small style="float:left" v-on="on">
          <v-icon block color="green darken-2" fab small style="color: #efefef">edit</v-icon>
        </v-btn>
      </router-link>
    </Tooltip>

    <Tooltip v-slot:default="{on}" text="Eksportuj do pliku">
      <v-btn :disabled="!docAvailable || (!isConfirmed && !Settings.allowPrintWihoutConfirm())" block
             color="blue-grey darken-2" fab
             small style="max-width: 3.2rem"
             @click="toFile(props.item)" v-on="on">
        <v-icon style="color: #efefef">print</v-icon>
      </v-btn>
    </Tooltip>


    <Tooltip v-slot:default="{on}" text="Usuń">
      <v-btn block color="deep-orange darken-3" dark fab small
             style="max-width: 3.2rem;float:left;margin-left: .3rem"
             @click="deleteForm(props.item.id, props.index)" v-on="on">
        <v-icon dark>delete_forever</v-icon>
      </v-btn>
    </Tooltip>
  </v-layout>
</template>
<script>

import State from "../State"
import Settings from "@/plugins/Settings"
import Tooltip from "../../common/Tooltip.vue"

export default {
  props: ['docAvailable', 'props', 'isConfirmed'],
  components: {Tooltip, State},
  computed: {
    Settings() {
      return Settings
    }
  },
  methods: {
    deleteForm(props) {
      this.$emit('deleteForm', props)
    },
    toFile(props) {
      this.$emit('toFile', props)
    }
  }
}

</script>


<style scoped>

</style>